import React from 'react';
import { withStyles } from '@material-ui/styles';
import { withTranslation, Trans } from 'react-i18next';
import { Button, Grid } from '@material-ui/core';
import styles from '../../assets/jss/FormStyle';

function CButton(props) {
  const {
    classes,
    isFull,
    disabled,
    isMarginBottom,
    smallBtn,
    equalSpace,
    isReset,
    isVerify,
    disabledVerify,
    onReset,
    resetAlign,
    onVerify,
    onCancel,
    type,
  } = props;

  return (
    <Grid item xs={12}>

      <div
        className={`${classes.actionBtn} ${classes[isFull ? 'removePosition' : '']} ${classes[isReset ? 'flexEnd' : '']} ${classes[equalSpace ? 'templateBtn' : '']}`}
      >
        {isReset ? (
          <Button
            disabled={disabled}
            type="button"
            onClick={onReset}
            className={`${classes.activeButton} ${classes[isMarginBottom ? 'changeBg' : '']} ${classes[`${resetAlign}Align`]} ${classes[isFull ? 'marginBottomBtnTF' : '']} ${classes[smallBtn ? 'smallBtn' : '']}`}
          >
            <Trans>BUTTON.RESET_SETTING</Trans>
          </Button>
        ) : null}

        {isVerify ? (
          <Button
            disabled={disabledVerify}
            type="button"
            style={{ color: 'black' }}
            onClick={onVerify}
            className={`${classes.defaultButton} ${classes[isFull ? 'changeBg' : '']} ${classes[isMarginBottom ? 'marginBottomBtnTF' : '']} ${classes[smallBtn ? 'smallBtn' : '']}`}
          >
            Test Connection
          </Button>
        )
          : (
            <Button
              type="button"
              onClick={onCancel}
              className={`${classes.defaultButton} ${classes[isFull ? 'changeBg' : '']} ${classes[isMarginBottom ? 'marginBottomBtnTF' : '']} ${classes[smallBtn ? 'smallBtn' : '']}`}
            >
              <Trans>BUTTON.ABORT</Trans>
            </Button>
          )}
        <Button
          disabled={disabled}
          type="submit"
          className={`${classes.activeButton} ${classes[isMarginBottom ? 'marginBottomBtnTF' : '']} ${classes[smallBtn ? 'smallBtn' : '']}`}
        >
          <Trans i18nKey={type} />
        </Button>

      </div>
    </Grid>
  );
}

export default withTranslation()(withStyles(styles, { withTheme: true })(CButton));
